import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Flex } from '@h2/components/layout/flex'
import { Skeleton as SkeletonLoader } from '@h2/components/loading/skeleton'
import { Card } from '@h2/common/components/card'

import { Controls } from '../controls'

const Highlight = styled(SkeletonLoader)`
  grid-area: hlt;
  height: 100%;
`
const Wrap = styled(Flex)`
  height: 100%;
  flex-direction: column;
`
const Skeleton = ({ inDialog }) => {
  return (
    <Card useDetour inDialog={inDialog}>
      <Highlight />
      <Card.Content>
        <Wrap>
          <SkeletonLoader height="32px" margin="0 auto 25px auto" width="70%" />
          <Flex direction="column">
            <SkeletonLoader height="32px" margin="20px 0 40px 0" />
            <SkeletonLoader height="20px" width="50%" margin="0 auto" />
          </Flex>
          <Controls>
            <SkeletonLoader width="250px" height="45px" margin="0 0 0 auto" />
          </Controls>
        </Wrap>
      </Card.Content>
      <Card.Detour>
        <SkeletonLoader height="20px" margin="0 auto" width="60%" />
      </Card.Detour>
    </Card>
  )
}

Skeleton.propTypes = {
  inDialog: PropTypes.bool
}

export { Skeleton }
